import React from "react";
import TrashIcon from "../../../../assets/images/classes/trash_icon.svg"
import helpIcon from "../../../../assets/images/classes/icon-help-line.png"

const StudentsTable = ({ data, onDelete, onInitPassword, onUnlinkAccount, isEditable, onEditChange, validateInput }) => {
    return (
        <div className="relative w-full min-h-[200px] bg-white rounded-[20px] mb-[150px] max-w-[1044px] border-[1px] border-[#DADADA]"
            style={{ boxShadow : "0 2px 7px 0 rgba(0, 0, 0, 0.10)"}}

        >
            <div className="overflow-hidden mx-[27px] my-[32px] rounded-t-[20px]">
                {/* 삭제 버튼 영역 */}
                <div
                    className={`absolute left-[-50px] top-[98px] flex flex-col gap-[16px] ${
                        isEditable ? "" : "hidden"
                    }`}
                >
                    {data &&
                        data.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => onDelete(index)}
                            >
                                <img src={TrashIcon} alt="Trash Icon" />
                            </button>
                        ))}
                </div>

                <table className="table-auto w-full">
                    <thead className="bg-[#F3F7FF]">
                    <tr>
                        <th className="px-2 py-3 text-[18px] font-semibold text-[#9BA5C2] w-[72px]">
                            번호
                        </th>
                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[140px]">
                            이름
                        </th>
                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[140px] relative">
                            접속번호
                            <div className="relative inline-block ml-1 group">
                                <img
                                    className="cursor-help inline-block"
                                    src={helpIcon}
                                    alt="Help Icon"
                                />
                                {/* 툴팁 */}
                                <div
                                    className="absolute w-[210px] bottom-[-55px] left-[108px] -translate-x-1/2 mb-2 px-2 py-1 text-white bg-gray-800 rounded-md text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                    학생이 접속할 수 있는 서비스에서 공통 비밀번호로 사용할 수 있어요.
                                </div>
                            </div>
                        </th>

                        <th className="px-2 py-3- text-lg font-semibold text-[#9BA5C2] w-[200px]">
                            아크수학 아이디
                            <div className="relative inline-block ml-1 group">
                                <img
                                    className="cursor-help inline-block"
                                    src={helpIcon}
                                    alt="Help Icon"
                                />
                                {/* 툴팁 */}
                                <div
                                    className="absolute w-[210px] bottom-[-55px] left-[108px] -translate-x-1/2 mb-2 px-2 py-1 text-white bg-gray-800 rounded-md text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                    학생이 학부모(법정 대리인)동의를 통해 가입한 계정이에요.
                                </div>
                            </div>
                        </th>

                        <th className="px-2 py-3 text-lg font-semibold text-[#9BA5C2] w-[160px]">
                            닉네임
                        </th>
                        <th className="px-2 py-3- text-lg font-semibold text-[#9BA5C2] w-[139px]">
                            비밀번호
                            <div className="relative inline-block ml-1 group">
                                <img
                                    className="cursor-help inline-block"
                                    src={helpIcon}
                                    alt="Help Icon"
                                />
                                {/* 툴팁 */}
                                <div
                                    className="absolute w-[210px] bottom-[-55px] left-[-50px] mb-2 px-2 py-1 text-white bg-gray-800 rounded-md text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                    아크수학 계정의 비밀번호는 학생 또는 학부모가 설정했어요.
                                </div>
                            </div>
                        </th>
                        <th className="px-2 py-3 text-[16px] font-semibold text-[#9BA5C2] w-[139px] leading-[18px]">
                            아크수학 아이디<br/> 연동 해제
                        </th>
                    </tr>
                    </thead>
                    <tbody className="border-r border-l border-[#E9E9E9]">
                    {data && data.length > 0 ? data.map((item, index) => (
                        <tr
                            key={index}
                            className={`bg-white border-b text-[#5e6169] text-[14px] font-[500] ${index < data.size ? 'border-b' : ''}`}
                        >
                            <td className="px-3 h-[56px] text-sm font-medium items-center justify-center  border-r">
                                {isEditable ? (
                                    <input
                                        type="text"
                                        value={item.number}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            let regex = /^[0-9]*$/;
                                            if (regex.test(value)) {
                                                onEditChange(index, value, "number"); // 유효한 값만 업데이트
                                            }
                                        }}
                                        onBlur={(e) => validateInput(index, e.target.value, "number")} // 포커스 아웃 시 중복 체크
                                        className="border rounded py-1 max-w-full text-center w-[40px] h-[36px]"
                                    />
                                ) : (
                                    item.number
                                )}
                            </td>
                            <td className="px-4 h-[50px] text-sm font-medium items-center justify-center border-r">
                                {isEditable ? (
                                    <input
                                        type="text"
                                        value={item.name}
                                        onChange={(e) => {
                                            onEditChange(index, e.target.value, "name")
                                        }}
                                        onBlur={(e) => validateInput(index, e.target.value, "name")} // 포커스 아웃 시 중복 체크
                                        className="border rounded py-1 max-w-full text-center w-[99px] h-[36px]"
                                    />
                                ) : (
                                    item.name
                                )}
                            </td>
                            <td className="px-4 h-[50px] text-sm font-medium items-center justify-center border-r">
                                {isEditable ? (
                                    <input
                                        type="text"
                                        value={item.password}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            // 영어, 한글, 숫자만 허용하는 정규식
                                            let regex = /^[0-9]*$/;
                                            if (regex.test(value) && value.length <= 4) {
                                                onEditChange(index, e.target.value, "password")
                                            }
                                        }}
                                        onBlur={(e) => validateInput(index, e.target.value, "password")} // 포커스 아웃 시 유효성체크
                                        className="border rounded py-1 max-w-full  text-center w-[100px] h-[36px]"
                                    />
                                ) : (
                                    item.password
                                )}
                            </td>
                            <td className="px-4 h-[50px] text-sm font-medium items-center justify-center border-r leading-tight">
                                {item.id ? item.id : "아직 해당 학생이 아크수학 아이디를 만들지 않았습니다."}
                            </td>

                            <td className="px-4 h-[50px] text-sm font-medium items-center justify-center border-r">
                                {item.profileName ? item.profileName : "-"}
                            </td>
                            <td className="px-4 h-[50px] text-sm font-medium border-r align-middle">
                                {item.id ? (
                                    <button
                                        className="border-[2px] border-solid border-[#557CFC] rounded-[15px] w-[76px] h-[30px] text-[#355BDF] font-bold hover:bg-gray-100"
                                        id={item.id}
                                        onClick={() => onInitPassword(index)}
                                    >초기화
                                    </button>) : "-"}

                            </td>
                            <td className="px-4 h-[50px] text-sm font-medium align-middle">
                                {item.id ? (
                                    <button
                                        className="border-[2px] border-solid border-[#557CFC] rounded-[15px] w-[76px] h-[30px] text-[#355BDF] font-bold hover:bg-gray-100"
                                        onClick={() => onUnlinkAccount(index)}
                                    >연동 해제
                                    </button>
                                ) : "-"}
                            </td>
                        </tr>
                    )) : <tr>
                        <td colSpan="7" className="py-5">클래스에 학생이 없습니다.</td>
                    </tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentsTable;
